module.exports = __webpack_public_path__ + "img/mobile-wallet.b17e58f8.png";